import React from "react";
import {Box, Stack, Divider, Grid} from '@mui/material';
import DateRangeForm from "../../../common/DateRangeForm";
import StatsItem from "./StatsItem";
import useGetCampaignsMetrics from "./hooks/useGetCampaignsMetrics";
import {getYearRange} from "_helpers";

export default function PerformanceMetrics({yearCount, startDate, endDate, setDates, dateParams}) {
    const { data } = useGetCampaignsMetrics(dateParams)

    return(
        <Box mt={{ xs: '14px', sm: '20px', }}>
            <Stack
                sx={styles.root}
                direction={'column'}
                divider={<Divider orientation={'horizontal'} flexItem />}
            >
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} sx={styles.header}>
                    <Box component={'h2'} sx={styles.headerTitle}>
                        Performance Metrics
                    </Box>
                    <Stack direction={'row'} spacing={2} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                        <DateRangeForm
                            startDate={startDate}
                            endDate={endDate}
                            setDates={setDates}
                            label={'Viewing metrics for'}
                            additionalRanges={[
                                getYearRange(yearCount)
                            ]}
                        />
                    </Stack>
                </Stack>

                <Grid container columns={4} spacing={3} sx={styles.gridStyle}>
                    <StatsItem
                        label={'Number of Comments'}
                        entry={{ value: data.comments, formatStyle: 'number' }}
                        descriptionChildren={<Box>Proactive comments posted</Box>}
                    />
                    <StatsItem
                        label={'Unique Users Engaged'}
                        entry={{ value: data.engagements, formatStyle: 'number' }}
                        descriptionChildren={<Box>Unique users that Liked, Replied, or Followed after Acquire AI Outreach</Box>}
                    />
                    <StatsItem
                        label={'Number of Likes'}
                        entry={{ value: data.likes, formatStyle: 'number' }}
                    />
                    <StatsItem
                        label={'Number of Replies'}
                        entry={{ value: data.replies, formatStyle: 'number' }}
                    />
                </Grid>
            </Stack>
        </Box>
    )
}

const styles = {
    root: {
        borderRadius: '10px',
        border: '1px solid #B6BEBF98',
        background: '#fff',
    },

    header: {
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 0 },
        minHeight: { xs: 'auto', md: '73px' },
        zIndex: 10, // MUI draws a big padding over the header, so we need to make sure the header is on top so it's still interactable.
    },
    headerTitle: {
        m: 0,
        fontFamily: 'FustatBold',
        fontSize: { xs: '14px', md: '19px' },
    },
    gridStyle: {
        position: 'relative',
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 4 }
    },
}